import { render, staticRenderFns } from "./teach_info.vue?vue&type=template&id=61c045df&scoped=true"
import script from "./teach_info.vue?vue&type=script&lang=js"
export * from "./teach_info.vue?vue&type=script&lang=js"
import style0 from "./teach_info.vue?vue&type=style&index=0&id=61c045df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c045df",
  null
  
)

export default component.exports